var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullscreenView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.55,13.4a1,1,0,0,0-1.48,0l-5,5V15.8A1,1,0,1,0,2,15.8v5A1.18,1.18,0,0,0,3.18,22h5a1,1,0,1,0,0-2.08H5.5l5.05-5.05A1.05,1.05,0,0,0,10.55,13.4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.45,10.6a1,1,0,0,0,1.47,0l5-5V8.2A1,1,0,0,0,22,8.2v-5A1.19,1.19,0,0,0,20.81,2h-5a1,1,0,0,0,0,2.08h2.68l-5,5.05A1,1,0,0,0,13.45,10.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreenView);
export default __webpack_public_path__ + "static/media/fullscreen-view.fa4a14d541b28e14ce54dff0daf1ad1f.svg";
export { ForwardRef as ReactComponent };